import { render, staticRenderFns } from "./contactPatientDetail.vue?vue&type=template&id=2b494b30&scoped=true"
import script from "./contactPatientDetail.vue?vue&type=script&lang=js"
export * from "./contactPatientDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b494b30",
  null
  
)

export default component.exports